import React, { useEffect, useState } from 'react';
import { ToastContainer } from 'react-bootstrap';
import StatusToast from './StatusToast';
import { StatusToastType, StatusToastContainerType } from './types';

const StatusToastContainer = ({ Toasts }: StatusToastContainerType) => {
  const generateKey = (toast: StatusToastType, index: number) => {
    const formattedPre = encodeURIComponent(toast.Message.substring(0, 20));
    return `${formattedPre}_${toast.Timestamp}_${index}`;
  };

  const [toastItems, setToastItems] = useState<StatusToastType[]>([]);

  // Sync local items with prop; do not force-clear so IsAutohide=false toasts persist
  useEffect(() => {
    setToastItems(Toasts);
  }, [Toasts]);

  return (
    <ToastContainer className="position-fixed p-24" position="bottom-end">
      {toastItems != null &&
        toastItems.length > 0 &&
        toastItems.map((toast, index) => (
          <StatusToast
            key={generateKey(toast, index)}
            IsFailed={toast.IsFailed}
            Message={toast.Message}
            Timestamp={toast.Timestamp}
            Title={toast.Title}
            DelayMs={toast.DelayMs}
            IsAutohide={toast.IsAutohide}
          />
        ))}
    </ToastContainer>
  );
};

export default StatusToastContainer;
export { StatusToastContainer };
